import { ASSETS } from "@/lib/constants";

// The source map is a light/parchment infographic. We invert it (invert + hue-rotate)
// so the USA renders dark with white/light map lines to match the app's black theme,
// while keeping all labels and legend colors legible.
const MAP_FILTER = { filter: "invert(0.92) hue-rotate(180deg) saturate(1.15) contrast(1.05)" };

export function CommunityMap({ heading = "Mapping the Nation Across the States", subheading, compact = false }) {
  return (
    <div className="bg-black border border-[#D4AF37]/30 p-4 sm:p-6">
      {heading && (
        <div className="mb-4">
          <div className="text-xs tracking-[0.25em] uppercase text-[#D4AF37] font-semibold mb-1">Census Map · 2020 PL 94-171</div>
          <h3 className="font-serif-display text-2xl sm:text-3xl text-[#F5F3EF] tracking-tight">{heading}</h3>
          {subheading && <p className="text-sm text-[#A8A29E] mt-2 max-w-3xl">{subheading}</p>}
        </div>
      )}
      <div className="overflow-hidden border border-[#D4AF37]/20 bg-[#0A0A0A]">
        <img
          src={ASSETS.communityMap}
          alt="Map of majority-Black communities, neighborhoods, and historic districts across the United States (2020 Census)"
          style={MAP_FILTER}
          className={`w-full object-contain ${compact ? "max-h-[520px]" : ""}`}
          loading="lazy"
          data-testid="community-map-image"
        />
      </div>
      <p className="text-[11px] text-[#A8A29E]/70 mt-3 leading-relaxed">
        Sources: 2020 U.S. Census Bureau (PL 94-171), National Register of Historic Places, local historic-district designations, and academic research.
      </p>
    </div>
  );
}
